GP.views.CommentListItem = Backbone.Marionette.CompositeView.extend({
    template: function(serialized_data) {
        var _template = 'content-comment';
        var tag_data = serialized_data.comment.tag;
        var account_status = serialized_data.comment.account_status;
        var tags = [];
        // Check if there's more than one tag.
        if (tag_data && tag_data.indexOf(',') > 0) {
            tags = tag_data.split(',');
        } else {
            tags.push(tag_data);
        }

        // Show the deleted comment template
        _.each(tags, function(tag) {
            if ((GP.Util.check_obj(tag) && tag.trim() == 'DELETED') ||
                account_status == 'ADMIN_DISABLED' ||
                account_status == 'USER_DISABLED' ||
                account_status == 'SCAMMER_DISABLED') {
                _template = 'content-comment-deleted';
            }
        });

        return template(_template, serialized_data);
    },
    initialize:function(options) {
        this.collection = this.model.get('replies');
        this.parent = options.parent_model; //grab parent model
    },
    className: function() {
        if (this.model.get('tag') == 'DELETED' ||
            this.model.get('account_status') == 'ADMIN_DISABLED' ||
            this.model.get('account_status') == 'USER_DISABLED' ||
            this.model.get('account_status') == 'SCAMMER_DISABLED') {
            return 'comment-item deleted';
        } else {
            if (this.model.get('reply_count') == null) {
                return 'comment-item-reply';
            }
            return 'comment-item';
        }
    },
    tagName: 'li',
    childViewContainer : '.comment-reply-list',
    attributes: function() {
        var self = this;
        return {
            id: function() {
               return ('comment' + self.model.get('comment_id'));
            }
        };
    },
    templateHelpers: function() {
        var self = this;

        return {
            delete_option: function() {
                return ((self.model.get('comment_duid') == GP.sdata.my_user.duid) ||
                    (typeof self_profile_view !== 'undefined' && self_profile_view));
            },
            // report_option: function() {
            //     return (self.model.get('comment_duid') != GP.sdata.my_user.duid);
            // },
            // show_bullet: function() {
            //     return ((self.model.get('comment_duid') != GP.sdata.my_user.duid) && ((self.model.get('comment_duid') == GP.sdata.my_user.duid) || self.model.get('my_profile')));
            // },
            profile_url: function() {
                return GP.Util.clean_url('/members/user/profile/', { duid: self.model.get('comment_duid') });
            },
            is_parent : function() {
                return (self.model.get('reply_count') != null);
            },
            more_replies : function() {
                return (self.model.get('reply_count') > 4 && self.model.get('replies').length != self.model.get('reply_count'));
            },
            report_option: function() {
                return self.model.get('comment_duid') != GP.sdata.my_user.duid;
            }
        };
    },
    serializeData: function() {
        // overwritten function for passing custom data to handlebars template
        var data = {};
        data = {
            comment: this.model.toJSON()
        };

        // Set the report url
        report_data = {
            reported_duid: this.model.get('comment_duid'),
            reported_from: 'comment',
            comment_id: this.model.get('comment_id'),
        };
        data.report_url = GP.Util.clean_url('/members/user/report_user/', report_data);

        return data;
    },
    ui: {
        btn_delete: '.btn-reply-delete',
        btn_c_delete: '.btn-comment-delete',
        alert_throttled: '.alert-throttled',
        alert_id_throttled: '.alert-id-throttled',
        alert_general_error: '.alert-general-error',
        media_comment_reply_input_wrap: '.media-comment-reply-input-wrap',
        reply_container: '.media-comment-reply-region',
        btn_show_reply: '.btn-show-reply',
        btn_reply_comment: '.btn-post-reply',
        reply_input: '.comment-reply-textarea',
        btn_more_replies: '.btn-more-replies',
        btn_cancel_reply: '.btn-cancel-reply',
        btn_comment_options : '.btn-comment-options',
    },
    events: {
        'click @ui.btn_delete': 'delete_reply',
        'click @ui.btn_c_delete': 'delete_comment',
        'click @ui.btn_show_reply' : 'show_reply',
        'click @ui.btn_cancel_reply' : 'hide_reply',
        'click @ui.btn_reply_comment' : 'add_reply',
        'click @ui.btn_more_replies' : 'show_more_replies',
        'click @ui.btn_comment_options' : 'toggle_comment_options',
        'keydown @ui.reply_input' : 'reply_input_keydown',
        'keyup @ui.reply_input' : 'check_comment_reply_char',
        'focus @ui.reply_input' : 'reply_comment_input_selected',
    },
    modelEvents: {
        'change:comment_throttled_hourly': 'throttled_notice_hourly',
        'change:comment_throttled_daily': 'throttled_notice_daily',
        'change:id_throttled': 'id_throttled_notice',
        'change:general_error': 'general_error',
    },
    onRender: function() {
        // Format and display timestamp
        jQuery.timeago.settings.strings = GP.Util.configs.timeago;
        this.$el.find('.timeago').timeago();
    },
    onShow: function() {

    },
    delete_reply: function(e) {
        $('.comment-options-dropdown').hide();
        e.preventDefault();
        e.stopPropagation();
        if (confirm(js_lang.content.confirm_del_commment)) {
            var self = this;
            var post_data = {
                content_id: this.model.get('content_id'),
                comment_id: this.model.get('comment_id'),
                comment_duid: this.model.get('comment_duid'),
                parent_comment_id: this.model.get('parent_comment_id')
            };

            // If viewing your own profile set profile_duid param
            if (typeof self_profile_view !== 'undefined' && self_profile_view) {
                post_data.profile_duid = GP.sdata.my_user.duid;
            }

            $.post('/members/content/del_comment', post_data)
                .done(function(data) {
                    if (data.status) {
                        self.model.set('tag', 'DELETED');
                        self.render();
                    }
                });
        }
    },
    delete_comment: function(e) {
        $('.comment-options-dropdown').hide();
        e.preventDefault();
        e.stopPropagation();
        if (confirm(js_lang.content.confirm_del_commment)) {
            var self = this;
            var post_data = {
                content_id: this.model.get('content_id'),
                comment_id: this.model.get('comment_id'),
                comment_duid: this.model.get('comment_duid'),
                parent_comment_id: this.model.get('parent_comment_id')
            };

            // If viewing your own profile set profile_duid param
            if (typeof self_profile_view !== 'undefined' && self_profile_view) {
                post_data.profile_duid = GP.sdata.my_user.duid;
            }

            $.post('/members/content/del_comment', post_data)
                .done(function(data) {
                    if (data.status) {
                        self.model.set('tag', 'DELETED');
                        self.model.set('replies', null);
                        self.render();
                    }
                });
        }
    },
    toggle_comment_options: function(e) {
        e.preventDefault();
        e.stopPropagation();
        var comment_id = this.model.get('comment_id');
        var opt_list = this.$el.find('#opt-'+comment_id);
        if(opt_list.is(':visible')) {
            $('.comment-options-dropdown').hide(); //hide others if open
            opt_list.hide();
        } else {
        $('.comment-options-dropdown').hide();
            opt_list.show();
        }
    },
    show_reply: function(e) {
        e.preventDefault();
        this.$el.find('.reply-wrap').show();
        this.$el.find('.btn-show-reply').hide();
    },
    hide_reply: function(e) {
        e.preventDefault();
        this.$el.find('.reply-wrap').hide(); //clear
        this.$el.find('.btn-show-reply').show();
    },
    reply_comment_input_selected: function() {
        this.ui.media_comment_reply_input_wrap.addClass('input-selected');
    },
    reply_input_keydown: function(e) {
        var key = e.which || e.keyCode;
        if (key && key == 13) {
            e.preventDefault();
            this.add_reply(e);
            return;
        }
    },
    add_reply: function(e) {
        e.preventDefault();
        var comment_data = {};
        var reply_input = this.$el.find('.comment-reply-textarea');
        comment_data.model = this.parent;
        comment_data.comment_model = this.model;
        comment_data.body = $.trim(reply_input.val());
        comment_data.parent_comment_id = reply_input.data('pid');
        comment_data.parent_comment_duid = this.model.get('comment_duid');
        // this.ui.comment_container.removeClass('hide');
        GP.vent.trigger('Content:add_comment', comment_data);
        //hide reply box
        this.$el.find('.comment-reply-textarea').val(''); //clear
        this.$el.find('.reply-wrap').hide(); //clear
        this.$el.find('.btn-show-reply').show();
    },
    show_more_replies: function(e) {
        e.preventDefault();
        e.stopPropagation();
        var self = this;
        var first_reply = this.model.get('replies').first();
        $.post('/members/content/get_comment_replies', {
            content_id: this.model.get('content_id'),
            parent_comment_id : first_reply.get('parent_comment_id'),
            last_comment_id: first_reply.get('comment_id')
        }).done(function(data) {
            if (data.status) {

                self.model.get('replies').add(data.comments);
                // Trigger deleted comments message.
                if (data.has_deleted) {
                    self.model.set('has_deleted_comments', true);
                }
                // Refresh nanoscroller in content viewer modal
                if (typeof(caller) !== 'undefined' && caller == 'content_modal' && MoshPit.get_size() != 'mobile') {
                    vent.trigger('ContentViewerLayout:refresh_nanoscroller');
                }
                self.$el.find('.show-more-replies').remove();
            }
        });

    },
    check_comment_reply_char: function(e) {
        e.preventDefault();
        var comment_text = $.trim(this.$el.find('.comment-reply-textarea').val());
        var reply_btn = this.$el.find('.btn-post-reply');
        if (comment_text.length === 0) {
            reply_btn.addClass('disabled');
        } else {
            reply_btn.removeClass('disabled');
        }
    },
    throttled_notice_hourly: function() {
        this.ui.alert_throttled.addClass('show');
    },
    throttled_notice_daily: function() {
        this.ui.alert_throttled.addClass('show daily');
    },
    id_throttled_notice: function() {
        this.ui.alert_id_throttled.addClass('show');
    },
    general_error: function() {
        this.ui.alert_general_error.addClass('show').text(this.model.get('general_error'));
    },
});

GP.views.CommentList = Backbone.Marionette.CollectionView.extend({
    childView: GP.views.CommentListItem,
    tagName: 'ul',
    className: 'media-comment-list'
});

GP.views.ReplyList = Backbone.Marionette.CollectionView.extend({
    tagName: 'ul',
    className: 'comment-reply-list'
});
